// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFieldStateType } from './IFieldStateType';
import {
    IFieldStateTypeFromJSON,
    IFieldStateTypeFromJSONTyped,
    IFieldStateTypeToJSON,
    IFieldStateTypeToJSONTyped,
} from './IFieldStateType';

/**
 * 
 * @export
 * @interface IHsaCustodianInfoDto
 */
export interface IHsaCustodianInfoDto {
    /**
     * 
     * @type {string}
     * @memberof IHsaCustodianInfoDto
     */
    hsa_custodian: IHsaCustodianInfoDtoHsaCustodianEnum;
    /**
     * 
     * @type {IFieldStateType}
     * @memberof IHsaCustodianInfoDto
     */
    hsa_custodian_state?: IFieldStateType;
}

/**
* @export
* @enum {string}
*/
export enum IHsaCustodianInfoDtoHsaCustodianEnum {
    UMB = 'UMB',
    NONE = 'NONE'
}


/**
 * Check if a given object implements the IHsaCustodianInfoDto interface.
 */
export function instanceOfIHsaCustodianInfoDto(value: object): value is IHsaCustodianInfoDto {
    if (!('hsa_custodian' in value) || value['hsa_custodian'] === undefined) return false;
    return true;
}

export function IHsaCustodianInfoDtoFromJSON(json: any): IHsaCustodianInfoDto {
    return IHsaCustodianInfoDtoFromJSONTyped(json, false);
}

export function IHsaCustodianInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHsaCustodianInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'hsa_custodian': json['hsa_custodian'],
        'hsa_custodian_state': json['hsa_custodian_state'] == null ? undefined : IFieldStateTypeFromJSON(json['hsa_custodian_state']),
    };
}

export function IHsaCustodianInfoDtoToJSON(json: any): IHsaCustodianInfoDto {
    return IHsaCustodianInfoDtoToJSONTyped(json, false);
}

export function IHsaCustodianInfoDtoToJSONTyped(value?: IHsaCustodianInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hsa_custodian': value['hsa_custodian'],
        'hsa_custodian_state': IFieldStateTypeToJSON(value['hsa_custodian_state']),
    };
}

